export default __webpack_public_path__ + "static/media/linkedin.17e919bb.png";